/** Browser tab titles. Scoring and scoreboard pages set their own (they know the tournament / shooter). */
export const TITLE_SUFFIX = ' · SMYM';

const TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/profile': 'Profile',
  '/complete-profile': 'Complete your profile',
  '/quiz': 'Quiz',
  '/leaderboard': 'Leaderboard',
  '/sponsors': 'Sponsors',
  '/events': 'Events',
  '/members': 'Members',
  '/super-admin': 'Super admin',
};

/** The tab title for an app route, or null when the page sets its own. */
export function pageTitle(pathname: string, search = '', signedIn = true): string | null {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (path === '/scoreboard' || path.startsWith('/scoreboard/')) return null;
  if (path === '/admin/scoring' || path.startsWith('/admin/scoring/')) return null;
  if (!signedIn) return `Sign in${TITLE_SUFFIX}`;
  if (path === '/admin') {
    const params = new URLSearchParams(search);
    const registrations = params.has('regs') || params.get('view') === 'registrations';
    return `${registrations ? 'Registrations' : 'Admin'}${TITLE_SUFFIX}`;
  }
  if (path.startsWith('/admin/quiz-preview/')) return `Quiz preview${TITLE_SUFFIX}`;
  const title = TITLES[path];
  return title ? `${title}${TITLE_SUFFIX}` : 'SMYM Chennai';
}

/** Scoring pages: "Amit Bisani · 10.9 Rifle Shooting · Scoring · SMYM". */
export function scoringTitle(...parts: Array<string | null | undefined>): string {
  return [...parts.filter((part): part is string => Boolean(part && part.trim())), 'Scoring'].join(' · ') + TITLE_SUFFIX;
}
